var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var $ = require('jquery');

require('angular-ui-router');
require('../../../services/search-results-utils');
require('../../../filters');
require('../../third-party/angular-preload-image');
require('../../../services/address-deduplication');
require('../../../services/branded-nav');
require('../../lrcarousel');

_module.requires.push(
    'ui.router',
    'angular-preload-image'
);

_module.controller('FeaturedPropertiesCtrl', [
    '$log',
    '$http',
    '$element',
    'srUtils',
    'addressDeduplicationService',
    '$brandedNav',

    function FeaturedPropertiesCtrl($log, $http, $element, srUtils, addressDeduplicationService, $brandedNav) {
        $log.debug('FeaturedPropertiesCtrl', this);

        var vm = this;
        vm.model = {
            loading: false,
            listings: [],
            fallbackHeroImage: '/images/search-results/hero_placeholder.png',
            affiliateEmail: undefined,
            slick: {
                numPerRow: 3,
                responsive: [ // More responseive settings are set in updateSlickSettings function
                    {
                        breakpoint: 1059
                    },
                    {
                        breakpoint: 729
                    }
                ]
            }
        };
        vm.events = {
            onBindingChanges: onBindingChanges
        };
        vm.services = {
            getNumAcross: getNumAcross
        };

        // Life Cycle Hooks
        vm.$onChanges = vm.events.onBindingChanges;

        // Functions
        function getNumAcross() {
            var width = $(window).width();

            if(width <= 679) {
                return 1;
            } else if(width <= 1059) {
                return 2;
            } else {
                return 3;
            }
        }

        function onBindingChanges(changes) {
            if(changes.affiliate && changes.affiliate.currentValue.email !== vm.model.affiliateEmail) {
                vm.model.affiliateEmail = changes.affiliate.currentValue.email;
                fetchRelatedProperties();
            }
        }

        function uniqueAddressFilter(result) {
            var normalizedAddress = addressDeduplicationService.parseAndNormalizeAddress(result.address);
            return normalizedAddress;
        }

        function fetchRelatedProperties() {
            if(vm.model.loading) return;

            var agentUrl = ['/v1/realtors/', vm.model.affiliateEmail, '/listings'].join('');
            var vendorUrl = ['/v1/vendors/', vm.affiliate.id, '/realtors/listings'].join('');
            var url = vm.affiliate.vendorId ? vendorUrl : agentUrl;
            vm.model.loading = true;

            $http.get(url, { cache: true })
            .then(function setListings(response) {
                var listings = response.data.data
                .filter(function (listing) { return !!listing.hero; })
                .map(function (listing) {
                    listing.hero = listing.hero || srUtils.getHeroImageUrl(listing);
                    listing.dom = srUtils.getDaysOnMarket(listing) || 0;
                    return listing;
                });
                listings = _.orderBy(listings, ['price'], ['desc']);
                listings = _.uniqBy(listings, uniqueAddressFilter);
                vm.model.listings.length = 0;
                vm.model.listings.push.apply(vm.model.listings, listings);

                updateSlickSettings();

                if(vm.isHidden && vm.model.listings.length){
                    show();
                } else if(!vm.model.listings.length) {
                    hide();
                }
            })
            .catch(function onError(err) {
                $log.error('FeaturedPropertiesCtrl -> fetchRelatedProperties -> Error', err);
                hide();
            })
            .finally(function () {
                vm.model.loading = false;
            });
        }

        function updateSlickSettings() {
            vm.model.slick.numPerRow = Math.min(3, vm.model.listings.length);
            vm.model.slick.responsive[0].settings = {
                slidesToShow: Math.min(2, vm.model.listings.length),
                slidesToScroll: Math.min(2, vm.model.listings.length),
                slidesPerRow: Math.min(2, vm.model.listings.length)
            };
            vm.model.slick.responsive[1].settings = {
                slidesToShow: Math.min(1, vm.model.listings.length),
                slidesToScroll: Math.min(1, vm.model.listings.length),
                slidesPerRow: Math.min(1, vm.model.listings.length),
                variableWidth: false,
                dots: true
            };
        }

        function hide() {
            $brandedNav.hide('featuredProperties');
            $element.css('display', 'none');
        }

        function show() {
            $brandedNav.show('featuredProperties');
            $element.css('display', '');
        }
    }
]);

_module.component('featuredProperties', {
    controllerAs: 'vm',
    controller: 'FeaturedPropertiesCtrl',
    template: require('./index.html'),
    bindings: {
        affiliate: '<'
    }
});
